var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { DateTimePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import { fieldValueIsSame, localeIsSame, getValue, } from '../../utils/formik';
var FormikDateTimePickerdUnmemoized = function (_a) {
    var _b;
    var name = _a.name, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = _a.required, required = _d === void 0 ? false : _d, _e = _a.formik, errors = _e.errors, values = _e.values, setFieldValue = _e.setFieldValue, datePickerProps = __rest(_a, ["name", "fullWidth", "required", "formik"]);
    var nameAsKey = name;
    var handleChange = React.useCallback(function (date) {
        setFieldValue(nameAsKey, date);
    }, [nameAsKey, setFieldValue]);
    var value = (_b = getValue(nameAsKey, values)) !== null && _b !== void 0 ? _b : null;
    return (React.createElement(DateTimePicker, __assign({ onChange: handleChange, inputFormat: "yyyy-MM-dd HH:mm (zzzz)", value: value, renderInput: function (inputProps) { return (React.createElement(TextField, __assign({}, inputProps, { margin: "none", variant: "outlined", error: Boolean(errors[nameAsKey]), helperText: errors[nameAsKey], fullWidth: fullWidth, required: required }))); } }, datePickerProps)));
};
var FormikDateTimePicker = React.memo(FormikDateTimePickerdUnmemoized, function (prevProps, nextProps) {
    return localeIsSame(prevProps, nextProps) && fieldValueIsSame(prevProps, nextProps);
});
export default FormikDateTimePicker;
